(() => {
  'use strict';
  const ROOT_SELECTOR = '[data-hh-rug-preview]';
  const NS = 'http://www.w3.org/2000/svg';
  const normalize = (value) => String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/\s+/g, ' ').trim();
  const asNumber = (value) => {
    const n = Number(String(value ?? '').replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const visible = (node) => !!(node && node.isConnected && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
  function candidateValue(node) {
    if (!node) return '';
    if (node.matches('input[type=radio],input[type=checkbox]')) return node.checked ? (node.value || node.getAttribute('aria-label') || 'yes') : '';
    return node.value ?? '';
  }
  function findByLabels(root, words) {
    const candidates = Array.from(document.querySelectorAll('input,select,textarea')).filter(el => !root.contains(el) && visible(el) && !el.disabled && !['hidden','submit','button','file'].includes(el.type));
    const terms = words.split(',').map(normalize).filter(Boolean);
    if (!terms.length) return null;
    return candidates.find(el => {
      const labels = [...(el.labels || [])].map(l => l.textContent);
      const wrapper = el.closest('fieldset, .field, .form-field, .form-group, [class*="field"], [class*="option"]');
      const wrapperText = wrapper?.querySelector('legend, label, [class*="label"]')?.textContent || '';
      const haystack = normalize([...labels, wrapperText, el.getAttribute('aria-label'), el.placeholder, el.name, el.id].join(' '));
      return terms.some(term => new RegExp('(^|[^a-z0-9])' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)', 'i').test(haystack));
    }) || null;
  }
  function pick(root, key) {
    const custom = root.dataset[key + 'Selector'];
    if (custom) { try { const el = document.querySelector(custom); if (visible(el)) return el; } catch (_) {} }
    const found = findByLabels(root, root.dataset[key + 'Labels'] || '');
    if (found && found.matches('input[type=radio],input[type=checkbox]') && found.name) {
      const group = Array.from(document.querySelectorAll('input')).filter(el => el.name === found.name && el.type === found.type && visible(el));
      return group.find(el => el.checked) || found;
    }
    return found;
  }
  function choiceText(el) {
    if (!el) return '';
    if (el.matches('select')) return [el.selectedOptions?.[0]?.textContent, el.value].filter(Boolean).join(' ');
    if (el.matches('input[type=radio], input[type=checkbox]')) return [el.labels?.[0]?.textContent, candidateValue(el)].filter(Boolean).join(' ');
    return String(candidateValue(el));
  }
  function svgNode(svg, tag, attributes) {
    const node = document.createElementNS(NS, tag);
    Object.entries(attributes).forEach(([key, val]) => node.setAttribute(key, String(val)));
    svg.appendChild(node); return node;
  }
  function render(root) {
    const widthEl = pick(root, 'width');
    const heightEl = pick(root, 'height');
    const shapeEl = pick(root, 'shape');
    const fringeEl = pick(root, 'fringe');
    const width = widthEl ? asNumber(candidateValue(widthEl)) : null;
    const height = heightEl ? asNumber(candidateValue(heightEl)) : null;
    const shape = normalize(choiceText(shapeEl));
    const fringe = normalize(choiceText(fringeEl));
    const circular = /yuvarlak|daire|round|circle/.test(shape);
    const hasFringe = /sacakli|sacak var|fringed|with fringe|yes|evet/.test(fringe) && !/sacaksiz|without|no fringe/.test(fringe);
    const svg = root.querySelector('svg');
    const dim = root.querySelector('[data-hh-dimensions]');
    const status = root.querySelector('[data-hh-status]');
    svg.replaceChildren();
    if (width === null || (!circular && height === null)) {
      dim.textContent = 'Ölçülerinizi giriniz.';
      status.textContent = !widthEl || (!heightEl && !circular) ? 'Ölçü alanları otomatik bulunamadı; bağlantı ayarları gerekebilir.' : 'En ve boy ölçülerini giriniz.';
      return;
    }
    const effectiveHeight = circular ? width : height;
    if (width > 200) { dim.textContent = 'En fazla 200 cm genişlik'; status.textContent = 'Geçerli bir ölçü giriniz.'; return; }
    if (effectiveHeight > 2000) { dim.textContent = 'Boy çok büyük'; status.textContent = 'Geçerli bir ölçü giriniz.'; return; }
    dim.textContent = circular ? `Çap: ${width} cm` : `${width} × ${effectiveHeight} cm`;
    status.textContent = [circular ? 'Yuvarlak' : 'Dikdörtgen', hasFringe ? 'Saçaklı' : 'Saçaksız'].join(' · ');
    const maxW = 284, maxH = 245;
    const scale = Math.min(maxW / width, maxH / effectiveHeight);
    const w = width * scale, h = effectiveHeight * scale;
    const x = (360 - w) / 2, y = (330 - h) / 2;
    const fill = '#cbbca5', stroke = '#9b8a73';
    if (circular) {
      const r = w / 2, cx = 180, cy = 165;
      if (hasFringe) for (let i = 0; i < 72; i++) {
        const a = i * Math.PI * 2 / 72;
        svgNode(svg,'line',{x1:cx+r*Math.cos(a),y1:cy+r*Math.sin(a),x2:cx+(r+10)*Math.cos(a),y2:cy+(r+10)*Math.sin(a),stroke,'stroke-width':1.6,'stroke-linecap':'round'});
      }
      svgNode(svg,'circle',{cx,cy,r,fill,stroke,'stroke-width':2});
      svgNode(svg,'circle',{cx,cy,r:Math.max(0,r-6),fill:'none',stroke:'#e7ddcd','stroke-width':2});
    } else {
      if (hasFringe) {
        const count = Math.max(2,Math.ceil(w / 9));
        for (let i = 0; i <= count; i++) {
          const px = x + i * w / count;
          svgNode(svg,'line',{x1:px,y1:y,x2:px,y2:y-12,stroke,'stroke-width':1.7,'stroke-linecap':'round'});
          svgNode(svg,'line',{x1:px,y1:y+h,x2:px,y2:y+h+12,stroke,'stroke-width':1.7,'stroke-linecap':'round'});
        }
      }
      svgNode(svg,'rect',{x,y,width:w,height:h,rx:Math.min(4,w/8,h/8),fill,stroke,'stroke-width':2});
      if (w > 16 && h > 16) svgNode(svg,'rect',{x:x+6,y:y+6,width:w-12,height:h-12,rx:2,fill:'none',stroke:'#e7ddcd','stroke-width':1.5});
    }
    svg.setAttribute('aria-label', `${dim.textContent}; ${status.textContent} halı önizlemesi`);
  }
  let scheduled = false;
  function refreshAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; document.querySelectorAll(ROOT_SELECTOR).forEach(render); });
  }
  function init() {
    if (!document.querySelector(ROOT_SELECTOR)) return;
    if (window.__hhRugPreviewInit) { refreshAll(); return; }
    window.__hhRugPreviewInit = true;
    document.addEventListener('input', refreshAll, true);
    document.addEventListener('change', refreshAll, true);
    document.addEventListener('click', () => setTimeout(refreshAll, 50), true);
    const observer = new MutationObserver((records) => {
      if (records.some(record => !record.target.closest?.(ROOT_SELECTOR))) refreshAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', refreshAll);
    refreshAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
